import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { Order, OrderStatus } from '@rosita/shared';
import { SEO } from '../../seo/useSEO';
import { t } from '../../i18n/pt';
import { api } from '../../lib/api';
import { useAuthStore } from '../../stores/authStore';
import { formatEur, formatDate } from '../../lib/format';
import { Button } from '../../components/ui/Button';
import { AccountPageHeader } from '../../components/account/AccountPageHeader';
import styles from './DashboardPage.module.scss';

interface OrderListResponse {
  items: Order[];
}

export default function DashboardPage(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const [orders, setOrders] = useState<Order[]>([]);

  useEffect(() => {
    void (async () => {
      try {
        const response = await api.get<OrderListResponse>('/orders?limit=20');
        setOrders(response.data.items);
      } catch {
        /* noop */
      }
    })();
  }, []);

  return (
    <>
      <SEO title={t.account.dashboard} noindex />
      <AccountPageHeader
        title={t.account.dashboard}
        lead={`Bem-vinda de volta${user?.firstName ? `, ${user.firstName}` : ''}. Aqui podes acompanhar as tuas encomendas e gerir os teus dados de conta.`}
      />

      {orders.length === 0 ? (
        <div className={styles.empty}>
          <img
            src="/cartemptystate.svg"
            alt=""
            aria-hidden
            className={styles.emptyIllustration}
          />
          <div className={styles.emptyContent}>
            <p className={styles.emptyMessage}>{t.account.noOrders}</p>
            <Button variant="primary" size="lg" to="/produtos">
              {t.cart.shopNow}
            </Button>
          </div>
        </div>
      ) : (
        <ul className={styles.orders}>
          {orders.map((o) => (
            <li key={o.id} className={styles.orderItem}>
              <div className={styles.orderMain}>
                <span className={styles.orderNumber}>{o.orderNumber}</span>
                <span className={styles.orderMeta}>
                  {formatDate(o.createdAt)} · {t.orderStatus[o.status as OrderStatus]}
                </span>
              </div>
              <div className={styles.orderSide}>
                <span className={styles.orderTotal}>{formatEur(o.total)}</span>
                <Link to={`/conta/encomendas/${o.orderNumber}`} className={styles.orderLink}>
                  {t.account.viewOrder}
                </Link>
              </div>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
